'use client';
import { useTranslations } from 'next-intl';
import { ComponentPropsWithoutRef, MouseEvent } from 'react';
import { EventService } from '@/shared/lib/event-service';
import { Icon } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const LogoutButton = (props: Props) => {
    const t = useTranslations();

    return (
        <Layout
            element="button"
            type="button"
            media={{
                initial: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem',
                    cursor: 'pointer',
                    padding: '0 0.5rem',
                },
            }}
            {...props}
            onClick={(e: MouseEvent<HTMLButtonElement>) => {
                props.onClick?.(e);
                EventService.trigger('account:auth:logout');
            }}
        >
            <Icon
                name="logout"
                className="logout-button__icon"
                style={{
                    width: '1.25rem',
                    height: '1.35rem',
                    flexShrink: 0,
                    color: 'var(--color-danger)',
                }}
            />
            <span>{t('WORDS.LOGOUT')}</span>
        </Layout>
    );
};
